import React, { useState, ReactNode, useContext, useEffect } from 'react';
import Sidebar from './Sidebar';
import { AppContext } from '../contexts/AppContext';
import { useUI } from '../contexts/UIContext';

const ReadOnlyBanner: React.FC<{ onManageSubscriptionClick: () => void }> = ({ onManageSubscriptionClick }) => {
  const ui = useUI();
  return (
  <div className="bg-red-600 text-white p-3 text-center sticky top-0 z-50 shadow-lg">
    <p className="font-bold">¡Cuenta Suspendida!</p>
    <p className="text-sm">Tu suscripción está vencida. La funcionalidad está limitada a solo lectura.</p>
    <div className="mt-2">
      <button 
        onClick={onManageSubscriptionClick}
        className="bg-white text-red-600 font-bold py-1 px-3 rounded-md text-sm mr-2 hover:bg-red-100"
      >
        Gestionar Suscripción
      </button>
      <button 
        onClick={() => ui.showModal('Próximamente', 'La funcionalidad para exportar datos estará disponible próximamente.')}
        className="border border-white text-white font-bold py-1 px-3 rounded-md text-sm hover:bg-red-700"
      >
        Exportar Datos
      </button>
    </div>
  </div>
  );
}

interface LayoutProps {
  children: ReactNode;
}

const SIDEBAR_COLLAPSED_KEY = 'tuclub.sidebar.collapsed';

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isReadOnly, setActiveScreen } = useContext(AppContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  // Estado de colapsado (solo aplica en desktop). Persistido en localStorage.
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    try { return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1'; } catch { return false; }
  });

  useEffect(() => {
    try { localStorage.setItem(SIDEBAR_COLLAPSED_KEY, isCollapsed ? '1' : '0'); } catch {}
  }, [isCollapsed]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const toggleCollapse = () => setIsCollapsed(prev => !prev);

  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden">
      <Sidebar isOpen={isSidebarOpen} isCollapsed={isCollapsed} onToggleCollapse={toggleCollapse} />

      {/* Overlay for mobile when sidebar is open */}
      {isSidebarOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black opacity-50 z-30"
          onClick={toggleSidebar}
        ></div>
      )}

      <div className="flex-1 flex flex-col min-w-0 h-screen">
        {/* Mobile Header */}
        <header className="md:hidden bg-white shadow z-10 flex items-center p-4 sticky top-0">
           <button onClick={toggleSidebar} className="text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500">
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </button>
            <h1 className="text-xl font-bold ml-4">Tu Club</h1>
        </header>

        <div className="flex-1 min-h-0 overflow-y-auto">
            {isReadOnly && <ReadOnlyBanner onManageSubscriptionClick={() => setActiveScreen('suscripcion')} />}
            <main className="p-4 sm:p-6">
              {children}
            </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;